import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import QUERY, {
	type IssueHierarchyViewQuery,
} from './__generated__/IssueHierarchyViewQuery.graphql';

export const issueHierarchyPageResource: RouteResource<
	PreloadedQuery<IssueHierarchyViewQuery, Record<string, unknown>>
> = createRelayResource<IssueHierarchyViewQuery>({
	type: 'RESOURCE1',
	getQuery: (_, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
		},
	}),
});
